import { apiClient } from "./apiClient";

// Tenant listesini getir (server-side pagination)
export async function getTenants(accessToken, params = {}) {
  const res = await apiClient.get("/tenants/list", {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  return res.data;
}

// Tek bir tenant getir
export async function getTenantById(accessToken, tenantId) {
  const res = await apiClient.get(`/tenants/${tenantId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Yeni tenant olustur
export async function createTenant(accessToken, tenantData) {
  const res = await apiClient.post("/tenants/create", tenantData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Tenant guncelle
export async function updateTenant(accessToken, tenantId, tenantData) {
  const res = await apiClient.put(`/tenants/${tenantId}`, tenantData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Tenant sil
export async function deleteTenant(accessToken, tenantId) {
  const res = await apiClient.delete(`/tenants/${tenantId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Tenant'a ait kullanıcıları getir
export async function getTenantUsers(accessToken, tenantId, params = {}) {
  const res = await apiClient.get(`/tenants/${tenantId}/users`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params, 
  });
  return res.data; 
}

// Tenant'a kullanıcı ekler
export async function createTenantUser(accessToken, tenantId, userData) {
  const res = await apiClient.post(`/tenants/${tenantId}/users`, userData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Kullanıcı günceller
export async function updateTenantUser(accessToken, tenantId, userId, userData) {
  const res = await apiClient.put(`/tenants/${tenantId}/users/${userId}`, userData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

//Kullanıcı siler
export async function deleteTenantUser(accessToken, tenantId, userId) {
  const res = await apiClient.delete(`/tenants/${tenantId}/users/${userId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// ==================== LOCATION API ====================

// Lokasyon listesi
export async function getTenantLocations(accessToken, tenantId, params = {}) {
  const res = await apiClient.get(`/tenants/${tenantId}/locations`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  return res.data;
}

// Lokasyon oluştur
export async function createTenantLocation(accessToken, tenantId, locationData) {
  const res = await apiClient.post(`/tenants/${tenantId}/locations`, locationData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Lokasyon güncelle
export async function updateTenantLocation(accessToken, tenantId, locationId, locationData) {
  const res = await apiClient.put(`/tenants/${tenantId}/locations/${locationId}`, locationData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Lokasyon sil
export async function deleteTenantLocation(accessToken, tenantId, locationId) {
  const res = await apiClient.delete(`/tenants/${tenantId}/locations/${locationId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// ===================== EDGE FONKSIYONLARI =====================

// Tenant'a ait edge cihazlari getir (server-side pagination)
export async function getTenantEdges(accessToken, tenantId, params = {}) {
  const res = await apiClient.get(`/edges/list`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params: { tenant_id: tenantId, ...params },
  });
  return res.data;
}

// Tenant'a edge cihaz ekle
export async function createTenantEdge(accessToken, tenantId, edgeData) {
  const res = await apiClient.post(`/edges/register/${tenantId}`, edgeData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge cihaz guncelle
export async function updateEdge(accessToken, edgeDbId, edgeData) {
  const res = await apiClient.put(`/edges/${edgeDbId}`, edgeData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge cihaz sil
export async function deleteEdge(accessToken, edgeDbId) {
  const res = await apiClient.delete(`/edges/${edgeDbId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Edge'i lokasyondan çıkar
export async function removeEdgeFromLocation(accessToken, edgeDbId) {
  const res = await apiClient.patch(`/edges/${edgeDbId}/remove-from-location`, {}, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}